<!--UNCOMMENT AND FIX WHEN ALL CONTROLS ARE READY-->
<div class="filter-list">
    <ng-template
        let-item
        let-i="index"
        let-isLast="last"
        ngFor
        [ngForOf]="filters">
        <mat-accordion
            displayMode="flat"
            togglePosition="before">
            <mat-expansion-panel
                *ngIf="item.IsCheckList || item.IsComboBox"
                expanded>
                <mat-expansion-panel-header>
                    <mat-panel-title> {{ item.DefaultCaption }} </mat-panel-title>
                    <button
                        st-click-stop-propagation
                        mat-icon-button
                        medium
                        [matTooltip]="getTooltipLabel(item.DefaultCaption)"
                        [disabled]="disabled"
                        (click)="removeFilter(item)">
                        <mat-icon>delete_outline</mat-icon>
                    </button>
                </mat-expansion-panel-header>
                <st-check-list
                    [tabindex]="i"
                    [value]="item.Value"
                    [label]="item.DefaultCaption"
                    [itemList]="item.Options"
                    [disabled]="disabled"
                    (changed)="onChange($event, item)"
                    (selectionChange)="onSelectionChange($event, item)" />
            </mat-expansion-panel>

            <mat-expansion-panel
                *ngIf="item.IsDateRange || item.IsDateTimeRange"
                expanded>
                <mat-expansion-panel-header>
                    <mat-panel-title> {{ item.DefaultCaption }} </mat-panel-title>
                    <button
                        st-click-stop-propagation
                        mat-icon-button
                        medium
                        [matTooltip]="getTooltipLabel(item.DefaultCaption)"
                        [disabled]="disabled"
                        (click)="removeFilter(item)">
                        <mat-icon>delete_outline</mat-icon>
                    </button>
                </mat-expansion-panel-header>
                <st-date-range-picker
                    [tabindex]="i"
                    [label]="item.DefaultCaption"
                    [value]="item.Value"
                    [disabled]="disabled"
                    (changed)="onChange($event, item)" />
            </mat-expansion-panel>

            <mat-expansion-panel
                *ngIf="item.IsCheckListTree || item.IsTree"
                expanded>
                <mat-expansion-panel-header>
                    <mat-panel-title> {{ item.DefaultCaption }} </mat-panel-title>
                    <button
                        st-click-stop-propagation
                        mat-icon-button
                        medium
                        [matTooltip]="getTooltipLabel(item.DefaultCaption)"
                        [disabled]="disabled"
                        (click)="removeFilter(item)">
                        <mat-icon>delete_outline</mat-icon>
                    </button>
                </mat-expansion-panel-header>
                <st-tree-checklist
                    [tabindex]="i"
                    [value]="item.Value"
                    [label]="item.DefaultCaption"
                    [itemList]="item.Options"
                    [disabled]="disabled"
                    (changed)="onChange($event, item)"
                    (selectionChange)="onSelectionChange($event, item)" />
            </mat-expansion-panel>

            <mat-expansion-panel
                *ngIf="item.IsCheckBox"
                expanded>
                <mat-expansion-panel-header>
                    <mat-panel-title> {{ item.DefaultCaption }} </mat-panel-title>
                    <button
                        st-click-stop-propagation
                        mat-icon-button
                        medium
                        [matTooltip]="getTooltipLabel(item.DefaultCaption)"
                        [disabled]="disabled"
                        (click)="removeFilter(item)">
                        <mat-icon>delete_outline</mat-icon>
                    </button>
                </mat-expansion-panel-header>

                <mat-form-field class="st-filter-list-item">
                    <mat-select
                        [disabled]="disabled"
                        [value]="item.Value"
                        [tabindex]="i"
                        (selectionChange)="onSelectionChange($event, item)"
                        (openedChange)="onOpenedChange($event, item)">
                        <mat-option
                            *ngFor="let item of item.Options"
                            [value]="item.id">
                            {{ item.title }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </mat-expansion-panel>

            <mat-expansion-panel
                *ngIf="item.IsSelect"
                expanded>
                <mat-expansion-panel-header>
                    <mat-panel-title> {{ item.DefaultCaption }} </mat-panel-title>
                    <button
                        st-click-stop-propagation
                        mat-icon-button
                        medium
                        [matTooltip]="getTooltipLabel(item.DefaultCaption)"
                        [disabled]="disabled"
                        (click)="removeFilter(item)">
                        <mat-icon>delete_outline</mat-icon>
                    </button>
                </mat-expansion-panel-header>

                <mat-form-field class="st-filter-list-item">
                    <mat-select
                        [disabled]="disabled"
                        [value]="item.Value"
                        [tabindex]="i"
                        (selectionChange)="onSelectionChange($event, item)"
                        (openedChange)="onOpenedChange($event, item)">
                        <mat-option
                            *ngFor="let item of item.Options"
                            [value]="item.id">
                            {{ item.title }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </mat-expansion-panel>

            <mat-expansion-panel
                *ngIf="item.IsExactDate"
                expanded>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{ item.Validation }}
                        <button
                            st-click-stop-propagation
                            mat-icon-button
                            medium
                            [matTooltip]="getTooltipLabel(item.DefaultCaption)"
                            [disabled]="disabled"
                            (click)="removeFilter(item)">
                            <mat-icon>delete_outline</mat-icon>
                        </button>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <p>Not implemented</p>
            </mat-expansion-panel>

            <mat-expansion-panel
                *ngIf="item.IsStaffIDList"
                expanded>
                <mat-expansion-panel-header>
                    <mat-panel-title> {{ item.DefaultCaption }} </mat-panel-title>
                    <button
                        st-click-stop-propagation
                        mat-icon-button
                        medium
                        [matTooltip]="getTooltipLabel(item.DefaultCaption)"
                        [disabled]="disabled"
                        (click)="removeFilter(item)">
                        <mat-icon>delete_outline</mat-icon>
                    </button>
                </mat-expansion-panel-header>
                <st-staff-id-list-multiple
                    [tabindex]="i"
                    [label]="item.DefaultCaption"
                    [value]="item.Value"
                    [disabled]="disabled"
                    [includeBlank]="true"
                    [includeMe]="true"
                    (changed)="onChange($event, item)" />
            </mat-expansion-panel>

            <mat-expansion-panel
                *ngIf="item.IsLookupList"
                expanded>
                <mat-expansion-panel-header>
                    <mat-panel-title> {{ item.DefaultCaption }} </mat-panel-title>
                    <button
                        st-click-stop-propagation
                        mat-icon-button
                        medium
                        [matTooltip]="getTooltipLabel(item.DefaultCaption)"
                        [disabled]="disabled"
                        (click)="removeFilter(item)">
                        <mat-icon>delete_outline</mat-icon>
                    </button>
                </mat-expansion-panel-header>
                <st-tags-autocomplete
                    [value]="item.Value"
                    [label]="item.DefaultCaption"
                    [disabled]="disabled"
                    [includeBlank]="true"
                    (changed)="onChange($event, item)" />
            </mat-expansion-panel>

            <mat-expansion-panel
                *ngIf="item.IsString"
                expanded>
                <mat-expansion-panel-header>
                    <mat-panel-title> {{ item.DefaultCaption }} </mat-panel-title>
                    <button
                        st-click-stop-propagation
                        mat-icon-button
                        medium
                        [matTooltip]="getTooltipLabel(item.DefaultCaption)"
                        [disabled]="disabled"
                        (click)="removeFilter(item)">
                        <mat-icon>delete_outline</mat-icon>
                    </button>
                </mat-expansion-panel-header>
                <st-text-field
                    [tabindex]="i"
                    [label]="item.DefaultCaption"
                    [value]="item.Value"
                    [disabled]="disabled"
                    (changed)="onChange($event, item)" />
                <mat-checkbox
                    [checked]="item.IsBlank"
                    (change)="onBlankChange($event, item)">
                    {{ languageSettings.PSTWebBlankOption }} {{ item.DefaultCaption }}
                </mat-checkbox>
            </mat-expansion-panel>
        </mat-accordion>
        <mat-divider *ngIf="!isLast" />
    </ng-template>
</div>
